export default "__VITE_ASSET__Bd124JF$__"